const STORAGE_KEY = 'reboot-replay-theme';
const HINT_STORAGE_KEY = 'reboot-replay-theme-hint-shown';

function getThemeMode() {
  return document.documentElement.dataset.themeMode === 'dark' ? 'dark' : 'light';
}

function updateToggle(toggle, mode) {
  const darkMode = mode === 'dark';
  const label = darkMode ? toggle.dataset.darkLabel : toggle.dataset.lightLabel;

  toggle.setAttribute('aria-pressed', String(darkMode));
  toggle.setAttribute('aria-label', label);
  toggle.title = label;
}

function applyThemeMode(mode, persist = true) {
  const normalizedMode = mode === 'dark' ? 'dark' : 'light';

  document.documentElement.dataset.themeMode = normalizedMode;
  document.documentElement.style.colorScheme = normalizedMode;
  document.querySelectorAll('[data-theme-mode-toggle]').forEach((toggle) => updateToggle(toggle, normalizedMode));

  if (!persist) return;

  try {
    localStorage.setItem(STORAGE_KEY, normalizedMode);
  } catch (error) {
    // The mode still applies for this page when storage is unavailable.
  }
}

function dismissThemeHint(toggle) {
  toggle.removeAttribute('data-theme-hint-visible');
}

function showThemeHint(toggle) {
  toggle.setAttribute('data-theme-hint-visible', '');
}

function shouldShowThemeHint() {
  try {
    return !localStorage.getItem(STORAGE_KEY) && !localStorage.getItem(HINT_STORAGE_KEY);
  } catch (error) {
    return false;
  }
}

function rememberThemeHintWasShown() {
  try {
    localStorage.setItem(HINT_STORAGE_KEY, 'true');
  } catch (error) {
    // Avoid repeatedly prompting when storage is unavailable.
  }
}

function initializeThemeModeToggles() {
  applyThemeMode(getThemeMode(), false);
  const showFirstVisitHint = shouldShowThemeHint();

  document.querySelectorAll('[data-theme-mode-toggle]').forEach((toggle) => {
    if (toggle.dataset.themeModeReady === 'true') return;

    toggle.dataset.themeModeReady = 'true';
    if (showFirstVisitHint) {
      showThemeHint(toggle);
      rememberThemeHintWasShown();
    }

    toggle.addEventListener('click', () => {
      dismissThemeHint(toggle);
      applyThemeMode(getThemeMode() === 'dark' ? 'light' : 'dark');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeThemeModeToggles);
} else {
  initializeThemeModeToggles();
}

document.addEventListener('shopify:section:load', initializeThemeModeToggles);
